import utils from '@/common/util/utils'

export const isLogin = () => {
  return utils.cookies.getCredential() !== 'none'
}
